function ExternalRedirect() {
  window.location.href = "https://www.regent-dental.co.uk/implants-ilkley";
  return null;
}
export default ExternalRedirect;